import {
  ActiveGangButton,
  ActiveGangButtonHolder,
  ButtonAndSettingsIcon,
  ButtonSection,
  ButtonSectionDown,
  ButtonSectionUp,
  DontShowOnPhone,
  DoubleButton,
  HorizontalLine,
  NavLinkText,
} from "./PaymentLink.styles";
import Buttons from "../../components/Button/button.component";
import { colors } from "../../theme/color";
import { IoSettingsOutline } from "react-icons/io5";
import React from "react";
import { ExportButton } from "../../components/Button/ExportButton";
import Button from "../../components/Button/Button";

type TabNavigationProps = React.PropsWithChildren<{
  onDropdownChange: (value: number) => void;
  onTabChange: (value: number) => void;
  onSettingsClick?: () => void;
  activeTab?: number;
  activeLink?: number;
}>;
export const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  activeLink,
  onTabChange,
  onDropdownChange,
  onSettingsClick,
}) => {
  const actions = ["All", "Inactive", "Active"];
  const buttons = [
    {
      style: {
        color: "white",
        backgroundColor: "#00A603",
      },
      title: "Payment Links",
    },
    {
      title: "Transaction History",
    },
  ];
  const activeText = (isActive: boolean) =>
    isActive ? `${colors.White}` : `${colors.DARK_GRAY}`;
  const activeColor = (isActive: boolean) =>
    isActive
      ? `${colors.ButtonBackgroundColors.primaryDefaultButton}`
      : "#f7f7f7";
  return (
    <ButtonSection>
      <ButtonSectionUp>
        <ButtonAndSettingsIcon>
          <DoubleButton>
            {buttons.map((button, index) => (
              <Buttons
                label={button.title}
                color={activeColor(activeTab === index + 1)}
                border={"8px"}
                cursor="pointer"
                height="44px"
                textColor={activeText(activeTab === index + 1)}
                handleClick={() => onTabChange(index + 1)}
                style={{
                  height: "44px",
                  borderRadius: "10px",
                  color: "#5E5E5E",
                  backgroundColor: "none",
                  ...(button?.style ?? {}),
                  width: "50%",
                }}
              />
            ))}
          </DoubleButton>
          <IoSettingsOutline
            cursor={"pointer"}
            fontSize={"20px"}
            onClick={onSettingsClick}
          />
        </ButtonAndSettingsIcon>
        {/* <ExportButton /> */}
      </ButtonSectionUp>
      <HorizontalLine />
      <ButtonSectionDown style={{ display: "none" }}>
        <ActiveGangButtonHolder>
          {actions.map((action, index) => (
            <ActiveGangButton
              active={activeLink === index + 1}
              onClick={() => onDropdownChange(index + 1)}
              key={action}
            >
              <NavLinkText active={activeLink === index + 1}>
                {action}
              </NavLinkText>
            </ActiveGangButton>
          ))}
        </ActiveGangButtonHolder>
      </ButtonSectionDown>
    </ButtonSection>
  );
};
